// extracted by mini-css-extract-plugin
module.exports = {"card":"seo-text_card__QtJTG","title":"seo-text_title__W0JE1","row":"seo-text_row__QC1D9"};